import { useState, useEffect, useCallback } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import CommandPalette from './CommandPalette';
import Toast from '../common/Toast';
import { useTenant } from '../../context/TenantContext';
import './MainLayout.css';

const MainLayout = () => {
  const { isImpersonating } = useTenant();
  const [isCommandPaletteOpen, setIsCommandPaletteOpen] = useState(false);
  const [isCreateTenantOpen, setIsCreateTenantOpen] = useState(false);

  const openCommandPalette = useCallback(() => setIsCommandPaletteOpen(true), []);
  const closeCommandPalette = useCallback(() => setIsCommandPaletteOpen(false), []);

  // Global keyboard shortcut for Cmd+K / Ctrl+K
  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        openCommandPalette();
      }
      if (e.key === 'Escape') {
        closeCommandPalette();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [openCommandPalette, closeCommandPalette]);

  return (
    <>
      {/* Impersonation Banner */}
      {isImpersonating && (
        <div className="impersonation-banner active">
          <span className="icon">
            <svg><use href="#icon-alert-triangle"></use></svg>
          </span>
          {' '}You are viewing as Super Admin — actions are logged
        </div>
      )}

      <Header onOpenCommandPalette={openCommandPalette} />

      <div className="main-layout">
        <Sidebar />
        <main className="content" id="main-content">
          <Outlet />
        </main>
      </div>

      {/* Command Palette */}
      <CommandPalette
        isOpen={isCommandPaletteOpen}
        onClose={closeCommandPalette}
        onCreateTenant={() => setIsCreateTenantOpen(true)}
      />

      {/* Toast Container */}
      <Toast />
    </>
  );
};

export default MainLayout;
